import React, { Component } from "react";

export default class InfoAwards extends Component {
  	
	render() {
		
		const post = this.props.post; 
		
		if (post.sectors) {
		
			return (
				
				<div className="c-info__section c-info__section--awards-space c-load">
				
					<div className="l-content">
				
						<div className="l-grid">
						
							<div className="l-grid__col">
													
								<div className="c-awards">
																
									<h3 className="c-awards__heading c-paragraph c-paragraph--small c-paragraph--heading" dangerouslySetInnerHTML={{__html:'Awards'}}></h3>
									
									<ul className="c-awards__list">
										
										{post.awards.map((item,i) =>
											{
												return (
													<li className="c-awards__item">
														<span className="c-awards__item__text c-awards__item__text--project" dangerouslySetInnerHTML={{__html:item.project}}></span>
														<span className="c-awards__item__text c-awards__item__text--competition" dangerouslySetInnerHTML={{__html:item.competition}}></span>
														<span className="c-awards__item__text c-awards__item__text--award" dangerouslySetInnerHTML={{__html:'<span>– </span>' + item.award}}></span>
													</li>
												)
											}
										)}
										
									</ul>
											
								</div>
								
							</div>
															
						</div>
					
					</div>
				
				</div>
				
			)
			
		} else {
			
			return false;
			
		}
		
	}
							
}